import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import english from './locales/EN';

let I18N;

const resources = {
	en: english
};

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init(
		{
			fallbackLng: 'en',
			debug: false,
			initImmediate: false,
			ns: 'meistro-translations',
			react: {
				useSuspense: true
			},
			// resources: {
			// 	en: { default: english }
			// },
			resources,
			interpolation: {
				escapeValue: false
			}
		},
		(err, t) => {
			if (err) {
				console.log('Error Initializing i18n');
			}

			I18N = {
				t
			};
		}
	);

export default I18N;
